import { gql } from '@apollo/client';

export const GET_ALL_SEGMENTS_METADATA = gql`
  query GetAllSegmentsMetadata($includeDeleted: Boolean) {
    getAllSegmentMetadataForMerchant(includeDeleted: $includeDeleted) {
      id
      name
      description
      lastCalculatedSize
      createdAt
      active
      lastCalculatedAt
    }
  }
`;

export const GET_SEGMENT_FOR_BUILDER = gql(/* GraphQL */ `
  query GetSegmentForBuilder($id: String!) {
    # Fetch metadata fields directly from the result type
    getSegmentMetadataBySegmentId(id: $id) {
      id
      name
      description
      active
      createdAt
      createdBy
      lastUpdatedAt
      lastUpdatedBy
      lastCalculatedAt
      lastCalculatedSize
      parentSegmentIds
      segment {
        rootOperator
        groups {
          id
          operator
          conditions {
            id
            conditionType
            ... on EventCondition {
              eventName
              operator
              numTimes
              timeBoundary {
                type
                conversionWindow {
                  num_unit
                  conversion_unit
                }
                timeRange {
                  fromTime
                  toTime
                }
              }
            }
            ... on UserPropertyCondition {
              propertyName
              comparisonOperator
              stringValue
              intValue
              floatValue
              boolValue
              stringArrayValue
            }
            ... on FunnelCondition {
              maxSecondsBetweenSteps
              timeBoundary {
                type
                conversionWindow {
                  num_unit
                  conversion_unit
                }
                timeRange {
                  fromTime
                  toTime
                }
              }
              steps {
                eventName
                countOperator
                numTimes
              }
            }
            ... on SegmentMembershipCondition {
              segmentId
              isMember
            }
          }
        }
      }
    }
  }
`);

// Query to estimate the size of a saved segment
export const ESTIMATE_SEGMENT_COUNT_QUERY = gql(/* GraphQL */ `
  query EstimateSegmentCount($input: GetSegmentUsersInput!) {
    estimateSegmentCount(input: $input)
  }
`);

// Query to estimate a provided segment definition (Input type was updated)
export const ESTIMATE_SEGMENT_DEFINITION_QUERY = gql(/* GraphQL */ `
  query EstimateSegmentDefinition($input: EstimateSegmentDefinitionInput!) {
    estimateSegmentDefinition(input: $input)
  }
`);
